import { useStore } from 'vuex';
import moment from 'moment';

/**
 * Composable para gestionar la API de tasa BCV
 * @returns {Object} - Métodos para gestionar tasa BCV
 */
export function useBcvRateAPI() {
  const store = useStore();

  /**
   * Obtiene la tasa BCV del día actual
   * @returns {Promise<Object>} - Objeto con la tasa BCV o {} si hay error
   */
  const getCurrentBcvRate = async () => {
    const today = moment().format('YYYY-MM-DD');
    const params = {
      url: `bcv_rate/date/${today}`,
      params: {
        currency: 'USD',
      },
    };

    try {
      const response = await store.dispatch('getData', params);
      if (response.code === 200) {
        return response.data || {};
      }
      return {};
    } catch (error) {
      console.error('Error loading BCV rate:', error);
      return {};
    }
  };

  return {
    getCurrentBcvRate,
  };
}
